import { createSlice } from '@reduxjs/toolkit'
import { getUserData } from '../../utils/Helper'

const readStoredSession = () => {
    const stored = getUserData()
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
        return null
    }
    const { token, userDetails, masterToken } = stored
    if (!token || !userDetails || typeof userDetails !== 'object' || Array.isArray(userDetails)) {
        return null
    }
    return { token, userDetails, masterToken: masterToken || false }
}

const storedSession = readStoredSession()

export const authSlice = createSlice({
    name: 'User',
    initialState: {
        token: storedSession?.token || false,
        userDetails: storedSession?.userDetails || false,
        masterToken: storedSession?.masterToken || false,
    },
    reducers: {
        loggedIn: (state, action) => {
            state.token = action.payload.token
            state.userDetails = action.payload.userDetails
            state.masterToken = action.payload.masterToken
        },
        logout: (state, action) => {
            state.masterToken = false
            state.token = false
            state.userDetails = false
        }
    }
})


export const { loggedIn, logout } = authSlice.actions

export default authSlice.reducer